/* eslint-disable react/no-unused-state,react/no-unescaped-entities */
import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  ModalBody,
  Modal,
  ModalHeader,
  ModalFooter,
  Spinner,
  Form,
  FormGroup,
  Input,
  Label
} from "reactstrap";
import BorderedTable from "../../../shared/components/table/BorderedTable";
import {
  getAllJobs,
  getMoreJobs,
  getJobsByCompanyEmail,
  getMoreJobsByCompanyEmail
} from "../../../redux/middlewares/Jobs/get_jobs";
import firebase from "../../../config/firebase";
import ViewJob from "../../ViewJobPage/components/viewJob";
import Select from "../../common/Select";
import SearchSection from "../../common/Search/JobSearch";
import JobsContainer from "../../common/jobsContainer";
import { CATEGORIES } from "../../../Utils";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import Search from "../../../services/search";
import { withRouter } from "react-router-dom";
import { PAID_JOBS_PATH } from "../../../URLs";
import "./DataTable.style.scss";

class DataTable extends PureComponent {
  constructor() {
    super();

    this.jobsRef = firebase.firestore().collection("jobs");

    this.heads = [
      {
        key: "SNo",
        name: "#",
        width: 80
      },
      {
        key: "id",
        name: "Id",
        width: 80
      },
      {
        key: "title",
        name: "Title",
        sortable: true
      },
      {
        key: "category",
        name: "Category",
        sortable: true
      },
      {
        key: "company",
        name: "Company",
        sortable: true
      },
      {
        key: "posted",
        name: "Posted At",
        sortable: true
      },
      {
        key: "status",
        name: "Status",
        sortable: true
      },
      {
        key: "action",
        name: "Action",
        sortable: true
      }
    ];

    this.status = [
      { label: "Active", value: "active" },
      { label: "Pending", value: "pending" },
      { label: "In-Active", value: "in-active" }
    ];
    this.postType = [
      { label: "Internal", value: "internal" },
      { label: "External", value: "external" }
    ];
    this.date = [
      { label: "Today", value: "today" },
      { label: "Yesterday", value: "yesterday" },
      { label: "Last Week", value: "lastWeek" },
      { label: "Last Month", value: "lastMonth" },
      { label: "Custom", value: "custom" }
    ];

    this.state = {
      rows: undefined,
      rowsPerPage: 20,
      page: 1,
      jobsArray: [],
      loading: true,
      initialLimit: 20,
      moreData: false,
      lastVisible: undefined,
      statusFilter: "All",
      isOpen: false,
      clickedJob: undefined,
      count: 0,
      whereClause: [],
      category: null,
      status: null,
      postType: null,
      allUsers: null,
      postedBy: null,
      searchKeyword: "",
      date: "",
      fromDate: "",
      toDate: "",
      currentPath: window.location.pathname
    };
    this.getAllData = undefined;
    this.getMoreData = undefined;
  }

  // Re-Initialize state State
  clearState = () => {
    this.setState({
      rows: undefined,
      rowsPerPage: 20,
      page: 1,
      jobsArray: [],
      loading: true,
      initialLimit: 20,
      moreData: false,
      lastVisible: undefined,
      statusFilter: "All",
      isOpen: false,
      clickedJob: undefined,
      count: 0,
      whereClause: [],
      category: null,
      status: null,
      postType: null,
      allUsers: null,
      postedBy: null,
      title: "",
      searchKeyword: "",
      date: "",
      fromDate: "",
      toDate: "",
      currentPath: this.props.location.pathname
    });
  };

  // Set Data of Initial Query
  setInitialData = docs => {
    this.setState({ moreData: false, page: 1 });
    if (!docs.empty) {
      // console.log({ docs });
      const { rowsPerPage, page } = { ...this.state };
      let jobsArray = [];
      docs.forEach(job => jobsArray.push({ ...job.data(), id: job.id }));

      let moreData = jobsArray.length > this.state.rowsPerPage ? false : true;
      // Checking for last data retrive
      let lastVisible = docs.docs[docs.docs.length - 1];
      console.log({ moreData, lastVisible, jobsArray });
      this.setState({ jobsArray, lastVisible, moreData }, () =>
        this.createRows(rowsPerPage, page)
      );
    } else
      this.setState({
        loading: false,
        jobsArray: [],
        rows: undefined,
        moreData: false
      });
  };

  // Set Data After Loadmore query
  setMoreData = snap => {
    const { rowsPerPage, jobsArray, page } = this.state;
    if (!snap.empty) {
      const newData = [];
      snap.forEach(docs => newData.push({ ...docs.data(), id: docs.id }));
      let allData = [...jobsArray, ...newData];
      //  Check if the entry is already available
      const uniqueData = Array.from(new Set(allData.map(a => a.id))).map(id => {
        return allData.find(a => a.id === id);
      });
      // Checking for last data retrive
      let lastVisible = snap.docs[snap.docs.length - 1];
      // let moreData = jobsArray.length < uniqueData.length;
      this.setState(
        {
          loading: false,
          jobsArray: uniqueData,
          lastVisible,
          page: page + 1
          // moreData
        },
        () => this.createRows(rowsPerPage, page + 1)
      );
    } else {
      // let moreData = jobsArray.length > (page + 1) * rowsPerPage ? true : false;
      this.setState({ moreData: false, page: page + 1, loading: false });
    }
  };

  // Handling this to change the query function
  InitialdataSelectionSetup = () => {
    // if (this.props.queryObject?.company) {
    //   const query = { ...this.props.queryObject };
    //   this.getAllData = params =>
    //     getJobsByCompanyEmail({ ...params, email: query.email });
    //   this.getMoreData = params =>
    //     getMoreJobsByCompanyEmail({ ...params, email: query.email });
    // } else {
    //   this.setState({ whereClause: [] });
    //   this.getAllData = params => getAllJobs({ ...params });
    //   this.getMoreData = params => getMoreJobs({ ...params });
    // }
    getAllJobs({ limit: this.state.initialLimit })
      .then(docs => {
        this.setInitialData(docs);
      })
      .catch(error => {
        console.log(error);
        toast(
          typeof error === "object" && error.message ? error.message : error
        );
        this.setState({ loading: false });
      });
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.queryObject !== prevProps.queryObject) {
      this.InitialdataSelectionSetup();
    }
    console.log({ props: this.props, prevProps });
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.clearState();
      if (this.props.location.pathname === PAID_JOBS_PATH) {
        this.setState(
          {
            whereClause: [["isPaid", "==", true]]
          },
          () => this.onSubmitFilter()
        );
      }
    }
    if (this.state.postType !== prevState.postType) {
      // console.log("POst TYPE CHANGED: ", this.state.postType, prevState);
      if (this.state.postType && this.state.postType.value === "internal") {
        const db = firebase.firestore();
        db.collection("users")
          .get()
          .then(docs => {
            let dataArr = [];
            docs.forEach(doc =>
              dataArr.push({ id: doc.data().id, name: doc.data().displayName })
            );
            if (dataArr.length > 0)
              this.setState({
                allUsers: dataArr
              });
          })
          .catch(error => {
            console.error(error.message);
            toast.error(error.message);
            this.setState({ postType: null, loading: false });
          });
      } else this.setState({ allUsers: null, postedBy: null });
    }
    if (
      prevProps.email_res !== this.props.email_res &&
      this.props.email_res !== undefined
    ) {
      this.toggleModal();
    }
  }

  componentWillUnmount() {
    // this.props.queryObject = {};
    this.setState({
      rows: undefined,
      rowsPerPage: 10,
      page: 1,
      jobsArray: [],
      loading: true,
      initialLimit: 15,
      moreData: false,
      lastVisible: undefined,
      json: undefined
    });
    this.InitialdataSelectionSetup = () => null;

    this.getAllData = undefined;
    this.getMoreData = undefined;
  }

  componentDidMount() {
    this.InitialdataSelectionSetup();
    if (window.location.pathname == PAID_JOBS_PATH) {
      this.setState(
        {
          whereClause: [["isPaid", "==", true]]
          // whereClause: [["postedAt", ">=", new Date("2020-11-16")]],
          // whereClause: [["postedAt", "<", new Date("2020-11-17")]]
        },
        () => this.onSubmitFilter()
      );
    }
  }

  // Change page and call Db
  onChangePage = pageToGo => {
    const { page, rowsPerPage, jobsArray } = this.state;
    // console.log({ pageToGo, page });
    if (pageToGo < page || jobsArray.length > pageToGo * rowsPerPage) {
      this.setState({ page: pageToGo, moreData: true }, () =>
        this.createRows(rowsPerPage, pageToGo)
      );
    } else if (pageToGo > page) {
      this.callMoreData();
    }
  };

  // Load More data from DB
  callMoreData = () => {
    const { rowsPerPage, lastVisible, statusFilter, whereClause } = this.state;
    if (lastVisible) {
      // this.setState({ loading: true });
      // this condition renders the status vice data
      // if (statusFilter && statusFilter.toLowerCase() !== "all") {
      if (whereClause.length > 0) {
        // console.log("callMoreDt", statusFilter);
        this.FilteredQuery()
          // .where("status", "==", statusFilter.toLowerCase())
          .orderBy("postedAt", "desc")
          .limit(rowsPerPage)
          .startAfter(lastVisible)
          .get()
          .then(snap => this.setMoreData(snap))
          .catch(error => console.error(error.message));
      } else {
        getMoreJobs({ limit: rowsPerPage, startAfter: lastVisible })
          .then(snap => {
            this.setMoreData(snap);
          })
          .catch(error => console.error(error.message));
      }
    }
  };

  // Convert seconds into date
  fromSecondsToDate = seconds => new Date(seconds * 1000).toLocaleDateString();

  // Creating rows which need to be rendered in Table
  createRows = (rowsPerPage, page) => {
    const rows = [];
    const jobs = [...this.state.jobsArray];
    try {
      for (let i = 0; i < jobs.length; i++) {
        rows.push({
          sno: i + 1,
          id: jobs[i].id,
          title: jobs[i].title,
          category: jobs[i].category,
          company: jobs[i].company.name,
          date: this.fromSecondsToDate(jobs[i].postedAt.seconds),
          status: jobs[i].status
        });
      }
    } catch (error) {
      console.error(error);
    }

    this.setState({ rows, loading: false });
  };

  updateJobStatus = (id, status) => {
    const clonedRows = [...this.state.rows];
    const jobsArray = [...this.state.jobsArray];
    const index = clonedRows.findIndex(e => e.id === id);
    const jobsIndex = jobsArray.findIndex(e => e.id === id);
    // console.log("object----------", clonedRows, index);
    if (index !== -1 && clonedRows[index].status !== status) {
      clonedRows[index].status = status;
      jobsArray[jobsIndex].status = status;
      console.log({ clonedRows: clonedRows[index] });
      this.setState({ rows: clonedRows, jobsArray });
    }
  };

  // Updateing is Feature Flag
  updateJobIsFeature = (id, isFeature) => {
    const jobsArray = [...this.state.jobsArray];
    const index = jobsArray.findIndex(e => e.id === id);
    // console.log("object----------", clonedRows, index);
    if (index !== -1 && jobsArray[index].isFeature !== isFeature) {
      jobsArray[index].isFeature = isFeature;
      // console.log({ clonedRows: jobsArray[index] });
      this.setState({ jobsArray });
    }
  };

  // On Job Deletetion
  onJobDeleteSuccess = id => {
    console.log("called deleted", { id });
    if (id) {
      let { jobsArray, rowsPerPage, page } = { ...this.state };
      const index = jobsArray.findIndex(e => e.id === id);
      if (index !== -1) {
        jobsArray.splice(index, 1);
        this.setState({ jobsArray }, () => this.createRows(rowsPerPage, page));
      }
    }
    this.toggleModal();
  };

  // Job Modal Toggle
  toggleModal = () => {
    this.setState(({ isOpen }) => ({ isOpen: !isOpen }));
  };

  onRowClickHandler = id => {
    const filter = this.state.jobsArray.filter(e => e.id === id);
    if (filter.length > 0)
      this.setState({ clickedJob: filter[0] }, this.toggleModal());
  };

  onChangeCategoryFilter = value => {
    let where = [...this.state.whereClause];
    const prevIndex = where.findIndex(e => e[0] === "category");
    // console.log({ value: value === [] });
    if (value === null || (Array.isArray(value) && value.length < 1)) {
      if (prevIndex !== -1) {
        where.splice(prevIndex, 1);
        this.setState({ whereClause: where, category: null });
      }
    } else {
      console.log({ value });
      const catArray = value.map(cat => cat.value);
      if (prevIndex !== -1) where[prevIndex][2] = [...catArray];
      else where.push(["category", "in", [...catArray]]);
      this.setState({ whereClause: where, category: value }, () =>
        console.log("Where Clauese----", this.state.whereClause)
      );
    }
  };
  onChangeSingleFilter = (field, value) => {
    console.log({ field, value });
    let where = [...this.state.whereClause];
    const prevIndex = where.findIndex(e => e[0] === field);
    console.log({ prevIndex, value });
    if (value === null || value === []) {
      if (prevIndex !== -1) {
        where.splice(prevIndex, 1);
        // console.log({ where });
        this.setState({ whereClause: where, [field]: null });
      }
    } else {
      if (prevIndex !== -1) where[prevIndex][2] = value.value;
      else where.push([field, "==", value.value]);
      this.setState({ whereClause: where, [field]: value }, () =>
        console.log("Where Clauese----", this.state.whereClause)
      );
    }
  };

  // DELETE PREVIUOS DATE FILTERS
  deleteDateFilters = operator => {
    let where = [...this.state.whereClause];
    const prevDates = where.filter(
      e => e[0] === "postedAt" && e[1] === operator
    );
    console.log({ prevDates });
    if (prevDates.length > 0) {
      prevDates.forEach(e => {
        let prevIndex = where.findIndex(i => i[0] === e[0] && i[1] === e[1]);
        console.log({ prevIndex });
        if (prevIndex !== -1) {
          where.splice(prevIndex, 1);
          console.log({ where });
        }
      });
    }
    return where;
  };

  // Select Custom Date
  onChangeCustomDate = e => {
    console.log({ e: e.target.value });
    let currField = e.target.name;
    let currValue = e.target.value;
    let where = [...this.state.whereClause];
    let loacale_Date = new Date(currValue);
    if (currField === "fromDate") {
      if (this.state.fromDate) {
        where = this.deleteDateFilters(">=");
        // this.setState({ toDate: "" });
      }
      where.push(["postedAt", ">=", new Date(currValue)]);
    }
    if (currField === "toDate") {
      if (this.state.toDate) {
        where = this.deleteDateFilters("<=");
        // this.setState({ fromDate: "" });
      }
      where.push([
        "postedAt",
        "<=",
        new Date(loacale_Date.setDate(loacale_Date.getDate() + 1))
      ]);
    }
    console.log({ where });
    this.setState({ [e.target.name]: currValue, whereClause: where });
  };

  // ["postedAt", ">=", new Date("2020-11-16")]

  // Formate date for firestore ()
  dateFormatForFirestore = date => {
    let day = date?.getDate();
    let month = date?.getMonth() + 1;
    let year = date?.getFullYear();
    console.log({ object: `${year}-${month}-${day}` });
    return `${year}-${month}-${day}`;
  };

  // Filter single day
  filterTodayDay = () => {
    return [
      ["postedAt", ">", new Date(this.dateFormatForFirestore(new Date()))]
    ];
  };
  // Filter range of days
  filterYesterday = (from, to) => {
    return [
      [
        "postedAt",
        ">",
        new Date(this.dateFormatForFirestore(new Date(Date.now() - 86400000)))
      ],
      ["postedAt", "<", new Date(this.dateFormatForFirestore(new Date()))]
    ];
  };
  // Filter range of days
  filterMultipleDays = (from, to) => {
    return [
      ["postedAt", ">", from],
      ["postedAt", "<=", to]
    ];
  };

  //  Date Filter
  onChangeDateFilter = (field, value) => {
    console.log({ field, value });
    let where = [...this.state.whereClause];
    const prevDates = where.filter(e => e[0] === "postedAt");
    console.log({ prevDates, value });
    if (prevDates.length > 0) {
      prevDates.forEach(e => {
        let prevIndex = where.findIndex(i => i[0] === e[0]);
        console.log({ prevIndex });
        if (prevIndex !== -1) {
          where.splice(prevIndex, 1);
          console.log({ where });
        }
      });
    }
    if (value === null || value === []) {
      this.setState({ whereClause: where, date: "" });
    } else {
      if (value.value !== "custom") {
        // :new Date(Date.now() - 86400000);
        let multipleDays = value.value === "lastWeek" ? 7 : 30;
        let day =
          value.value === "today"
            ? this.filterTodayDay()
            : value.value === "yesterday"
            ? this.filterYesterday()
            : this.filterMultipleDays(
                new Date(
                  this.dateFormatForFirestore(
                    new Date(Date.now() - 86400000 * multipleDays)
                  )
                ),
                new Date(
                  this.dateFormatForFirestore(new Date(Date.now() + 86400000))
                )
              );

        console.log({ day });
        console.log({ where, prevDates });
        where.push(...day);
      }
      this.setState({ whereClause: where, [field]: value }, () =>
        console.log("Where Clauese----", this.state.whereClause)
      );
    }
  };

  // Search Filter by Job Title

  // onChangeSearchFilter = e => {
  //   let where = [...this.state.whereClause];
  //   let value = e.target.value;
  //   const prevIndex = where.findIndex(e => e[0] === "title");
  //   console.log({ prevIndex, value });
  //   if (!value) {
  //     if (prevIndex !== -1) {
  //       where.splice(prevIndex, 1);
  //       // console.log({ where });
  //       this.setState({ whereClause: where, title: null });
  //     }
  //   } else {
  //     if (prevIndex !== -1) where[prevIndex][2] = value;
  //     else where.push(["title", "==", value]);
  //     this.setState({ whereClause: where, title: value }, () =>
  //       console.log("Where Clauese----", this.state.whereClause)
  //     );
  //   }
  // };

  FilteredQuery = () => {
    let where = [...this.state.whereClause];
    let query = this.jobsRef;
    console.log({ where });
    try {
      if (where) {
        if (where[0] instanceof Array) {
          // It's an array of array
          for (let w of where) {
            console.log({ w });
            query = query.where(...w);
          }
        } else {
          query = query.where(...where);
        }
        console.log({ query, where });
        return query;
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Filters on Status
  onSubmitFilter = s => {
    this.setState({ moreData: false });
    const { initialLimit, whereClause } = this.state;
    // const status = s.toLowerCase();
    console.log({ whereClause });
    if (whereClause.length > 0) {
      this.setState({ loading: true });
      this.FilteredQuery()
        // .where("status", "==", status)
        .orderBy("postedAt", "desc")
        .limit(initialLimit)
        .get()
        .then(snap => {
          console.log({ snap });
          this.setInitialData(snap);
        })
        .catch(error => {
          console.error(error.message);
          toast.error(error.message);
          this.setState({
            loading: false,
            moreData: false,
            jobsArray: [],
            rows: undefined,
            lastVisible: undefined,
            page: 1
          });
        });
    } else this.InitialdataSelectionSetup();
  };

  onClearFilters = () => {
    if (this.props.location.pathname === PAID_JOBS_PATH) {
      this.setState(
        {
          category: null,
          status: null,
          whereClause: [["isPaid", "==", true]],
          moreData: false,
          searchKeyword: "",
          date: "",
          toDate: "",
          fromDate: ""
        },
        () => this.onSubmitFilter()
      );
    } else {
      this.setState(
        {
          category: null,
          status: null,
          postType: null,
          whereClause: [],
          moreData: false,
          searchKeyword: "",
          date: ""
        },
        () => this.InitialdataSelectionSetup()
      );
    }
  };

  // callback of searchSection component
  searchFilterHandler = searchKeyword => {
    const { initialLimit, page, jobsArray, rowsPerPage } = this.state;
    console.log({ searchKeyword });
    if (!Search.has_initiated()) Search.init();
    this.setState({ searchKeyword, loading: true });
    Search.search_for(searchKeyword, {
      hitsPerPage: initialLimit,
      page: page - 1
    }).then(res => {
      console.log(res.hits, res);
      res.hits.forEach(hit => {
        if (!hit.postedAt.seconds) {
          hit.postedAt = {
            seconds: hit.postedAt._seconds,
            nanoseconds: hit.postedAt._nanoseconds
          };
        }
        hit.id = hit.objectID;
      });
      const more = page < res.nbPages ? true : false;
      const nextPage = page <= res.nbPages ? page + 1 : page;
      // console.log({ hits: res.hits });
      let allData = [...jobsArray, ...res.hits];
      console.log({ page });
      this.setState(
        {
          jobsArray: allData,
          moreData: more
          // page: nextPage
        },
        () => this.createRows(rowsPerPage, page)
      );
    });
  };

  onChangeSearchKeyword = searchKeyword => {
    // console.log({ searchKeyword });
    if (searchKeyword.length < 1) {
      console.log({ data: this.state.dataArray });
      this.setState({
        loading: true,
        dataArray: [],
        lastVisible: "",
        moreDataAvailable: true,
        page: 1,
        searchKeyword: ""
      });
      this.props
        .callInitialData({ limit: this.state.limit })
        .then(data => {
          this.setRenderableData(data);
        })
        .catch(error => {
          console.log(error);
          this.setState({
            loading: false,
            error
          });
        });
    } else {
      this.setState(
        { jobsArray: [], page: 1, moreData: false, searchKeyword },
        () => this.searchFilterHandler(searchKeyword)
      );
    }
  };

  // --- For force update all documents---
  // updateAllDocs = () => {
  //   console.log("called---");
  //   let that = this;
  //   const db = firebase.firestore();
  //   db.collection("jobs")
  //     .where("company.email", "==", "muhammad.arslan@denovers.com")
  //     .get()
  //     .then(function(querySnapshot) {
  //       console.log({ doc: querySnapshot });
  //       let dataArr = [];
  //       // querySnapshot.forEach(function(doc) {
  //       //   console.log({ object: doc.data() });
  //       //   dataArr.push(doc.data());
  //       //   // doc.ref
  //       //   //   .update({
  //       //   //     "company.id": "LoLwMyERao6dbJ0quZfp"
  //       //   //   })
  //       //   //   .then(() => {
  //       //   //     console.log(that.state.count + 1, " updated");
  //       //   //     that.setState({ count: that.state.count + 1 });
  //       //   //   })
  //       //   //   .catch(err => console.error(err.message));
  //       // });
  //       // if (dataArr.length > 0) {
  //       //   that.setState({ json: dataArr });
  //       // }
  //     });
  // };

  // DOwnload Jobs Document.
  // downloadObjectAsJson = (exportObj, exportName) => {
  //   let dataStr =
  //     "data:text/json;charset=utf-8," +
  //     encodeURIComponent(JSON.stringify(exportObj));
  //   let downloadAnchorNode = document.createElement("a");
  //   downloadAnchorNode.setAttribute("href", dataStr);
  //   downloadAnchorNode.setAttribute("download", exportName + ".json");
  //   document.body.appendChild(downloadAnchorNode); // required for firefox
  //   downloadAnchorNode.click();
  //   downloadAnchorNode.remove();
  // };

  render() {
    const {
      rows,
      moreData,
      page,
      loading,
      category,
      status,
      postType,
      allUsers,
      postedBy,
      searchKeyword,
      date,
      jobsArray
    } = this.state;
    // console.log({ date: this.state.clickedJob });

    return (
      <Col md={12} lg={12}>
        <Card>
          {this.state.clickedJob && (
            <Modal
              isOpen={this.state.isOpen}
              toggle={this.toggleModal}
              className="edit-job-modal"
            >
              <ModalHeader toggle={this.toggleModal}>Job</ModalHeader>
              <ModalBody>
                <ViewJob
                  job={this.state.clickedJob}
                  updateStatusInParent={this.updateJobStatus}
                  updateIsFeatureInParent={this.updateJobIsFeature}
                  onJobDeleteSuccess={this.onJobDeleteSuccess}
                  toggleParentModal={this.toggleModal}
                />
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" onClick={this.toggleModal} size="sm">
                  Cancel
                </Button>
              </ModalFooter>
            </Modal>
          )}
          <CardBody>
            {/* For Force Update Purpose */}
            {/* <button onClick={this.multiFilterHandler}> */}
            {/* <button onClick={this.updateAllDocs}>
              Update All Docs {this.state.count}
            </button> */}
            {/* {this.state.json && (
              <button
                onClick={() =>
                  this.downloadObjectAsJson(this.state.json, "FIRE")
                }
              >
                Download
              </button>
            )} */}
            {/* <Row>
              <Col md={1} style={{ display: "flex", alignItems: "flex-end" }}>
                <div className="card__title">
                  <h5 className="bold-text">Search</h5>
                </div>{" "}
              </Col>
              <Col md={7}>
                <Form>
                  <FormGroup>
                    <Row>
                      <Col md={8}>
                        <Input
                          type="search"
                          name="search"
                          id="exampleSearch"
                          placeholder="Paste Job Title"
                        />
                      </Col>
                      <Col md={4}>
                        <Button
                          outline
                          color="primary"
                          size="sm"
                          onClick={this.onSubmitFilter}
                        >
                          Submit
                        </Button>{" "}
                      </Col>
                    </Row>
                  </FormGroup>
                </Form>{" "}
              </Col>
            </Row> */}

            <Row>
              <Col md={4}></Col>
              <Col sm={12} md={4}>
                <SearchSection
                  searchFilterHandler={this.onChangeSearchKeyword}
                />
              </Col>
              <Col md={4}></Col>
            </Row>
            <Row>
              <Col
                sm={1}
                style={
                  searchKeyword
                    ? { display: "flex", alignItems: "center" }
                    : { display: "flex", alignItems: "center" }
                }
              >
                <div
                  className="card__title"
                  style={searchKeyword ? { marginBottom: "0px" } : void 0}
                >
                  <h5 className="bold-text">
                    {" "}
                    {searchKeyword ? "Search: " : "Filter:"}{" "}
                  </h5>
                </div>
              </Col>
              {searchKeyword ? (
                <Col md={4}>
                  <div className="filters-list">
                    {/* <h5>Search: </h5> */}
                    <li>
                      <span style={{ minWidth: "100%" }}>
                        {this.state.searchKeyword}
                      </span>

                      <img
                        src={require("../../../assets/images/close.png")}
                        alt="close"
                        onClick={() => this.onClearFilters()}
                      />
                    </li>
                  </div>
                </Col>
              ) : (
                <Col md={11}>
                  <Row>
                    {" "}
                    <Col md={3}>
                      <Select
                        placeholder="Categories"
                        value={category}
                        options={CATEGORIES.map(item => ({
                          value: item.name,
                          label: item.name
                        }))}
                        isMulti
                        onChange={this.onChangeCategoryFilter}
                        closeMenuOnSelect={false}
                      />
                    </Col>
                    <Col md={2} style={{ marginBottom: "10px" }}>
                      <Select
                        placeholder="Status"
                        options={this.status}
                        value={status}
                        isMulti={false}
                        onChange={val =>
                          this.onChangeSingleFilter("status", val)
                        }
                        closeMenuOnSelect={true}
                        isClearable={true}
                      />
                    </Col>
                    {this.state.currentPath !== PAID_JOBS_PATH && (
                      <>
                        <Col md={2} style={{ marginBottom: "10px" }}>
                          <Select
                            placeholder="Post Type"
                            value={postType}
                            options={this.postType}
                            isMulti={false}
                            onChange={val =>
                              this.onChangeSingleFilter("postType", val)
                            }
                            closeMenuOnSelect={true}
                            isClearable={true}
                          />
                        </Col>
                        {postType && postType.value === "internal" && (
                          <Col md={2} style={{ marginBottom: "10px" }}>
                            <Select
                              placeholder={
                                allUsers ? "Post Type" : "Loading..."
                              }
                              value={postedBy}
                              disabled={allUsers ? false : true}
                              options={
                                allUsers
                                  ? allUsers.map(item => ({
                                      value: item.name,
                                      label: item.name
                                    }))
                                  : null
                              }
                              isMulti={false}
                              onChange={val =>
                                this.onChangeSingleFilter("postedBy", val)
                              }
                              closeMenuOnSelect={true}
                              isClearable={true}
                            />
                          </Col>
                        )}
                      </>
                    )}
                    {/* date Section */}
                    <Col sm={12} md={3} style={{ marginBottom: "10px" }}>
                      <Select
                        placeholder="Date"
                        options={this.date}
                        value={date}
                        isMulti={false}
                        onChange={val => this.onChangeDateFilter("date", val)}
                        closeMenuOnSelect={true}
                        isClearable={true}
                        isSearchable={false}
                      />
                    </Col>
                    {date.value == "custom" && (
                      <>
                        <Col sm={12} md={3} style={{ marginBottom: "10px" }}>
                          <Label for="fromDate">From</Label>
                          <Input
                            type="date"
                            name="fromDate"
                            id="fromDate"
                            placeholder="From"
                            value={this.state.fromDate}
                            onChange={this.onChangeCustomDate}
                          />
                        </Col>
                        <Col sm={12} md={3} style={{ marginBottom: "10px" }}>
                          <Label for="toDate">To</Label>
                          <Input
                            type="date"
                            name="toDate"
                            id="toDate"
                            value={this.state.toDate}
                            placeholder="To"
                            onChange={this.onChangeCustomDate}
                          />
                        </Col>
                      </>
                    )}
                    <Col
                      md={2}
                      style={{
                        marginBottom: "10px",
                        display: "flex",
                        alignItems: "flex-end"
                      }}
                    >
                      <Button
                        outline
                        color="primary"
                        size="sm"
                        onClick={this.onSubmitFilter}
                        style={{ marginBottom: "0px" }}
                      >
                        Submit
                      </Button>{" "}
                    </Col>
                    <Col
                      md={2}
                      style={{
                        textAlign: "left",
                        marginBottom: "10px",
                        display: "flex",
                        alignItems: "flex-end"
                      }}
                    >
                      <Button
                        outline
                        color="danger"
                        size="sm"
                        onClick={this.onClearFilters}
                        style={{ marginBottom: "0px" }}
                      >
                        Clear
                      </Button>{" "}
                    </Col>
                  </Row>
                </Col>
              )}
            </Row>
            <div
              style={{
                minHeight: "400px",
                overflow: "auto",
                border: "2px solid #efefef"
              }}
            >
              {loading ? (
                <h3
                  style={{
                    height: "400px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <Spinner type="grow" color="info" />
                </h3>
              ) : rows ? (
                <BorderedTable
                  heads={this.heads}
                  rows={rows}
                  path="jobs"
                  dataArray={this.state.jobsArray}
                  onRowClickHandler={this.onRowClickHandler}
                  moreDataAvailable={this.state.moreData}
                  callMoreData={this.callMoreData}
                />
              ) : (
                // <JobsContainer
                //   initialStaticData={jobsArray}
                //   // callInitialData={this.getJobs}
                //   loadMoreData={() => this.onChangePage(page + 1)}
                //   categorizedData={this.state.categoriesArray}
                //   searchQuery={this.state.searchKeyword}
                //   pageBasePath={this.state.currentPath}
                // />
                <h3
                  style={{
                    height: "400px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  No Jobs Found!
                </h3>
              )}
            </div>
            {/* <Row style={{ margin: "1vw .2vw" }}>
              <Col sm={6}>
                <Button
                  color="primary"
                  size="sm"
                  disabled={page === 1}
                  onClick={() => this.onChangePage(page - 1)}
                >
                  Prev
                </Button>
              </Col>
              <Col sm={6} style={{ textAlign: "end" }}>
                <Button
                  color="primary"
                  size="sm"
                  disabled={!moreData}
                  onClick={() => this.onChangePage(page + 1)}
                >
                  Next
                </Button>
              </Col>
            </Row> */}
          </CardBody>
        </Card>
      </Col>
    );
  }
}
const mapStateToprops = state => {
  return {
    email_res: state.jobReducer.email_res
  };
};
export default connect(mapStateToprops, null)(withRouter(DataTable));
